"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const documentFileExtReg = /\.(doc|docx|xls|xlsx|ppt|pptx)$/i;
const imageFileExtReg = /.(jpe?g|png|gif|bmp|svg|tiff?)$/i;
var _default = exports.default = {
  name: 'FilePreview',
  props: {
    filePath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      visible: false
    };
  },
  computed: {
    fileExtension() {
      return this.getFileExtension(this.filePath ?? '').toUpperCase();
    },
    isImageFile() {
      return imageFileExtReg.test(this.filePath);
    },
    href() {
      const filePath = this.filePath;
      if (documentFileExtReg.test(filePath)) {
        return `https://view.officeapps.live.com/op/view.aspx?src=${this.filePath}`;
      }
      return filePath;
    }
  },
  methods: {
    getFileExtension(filename) {
      const lastDotIndex = filename.lastIndexOf('.');
      if (lastDotIndex === -1) {
        return '';
      }
      return filename.slice(lastDotIndex + 1);
    },
    handleImgClick() {
      this.visible = true;
    },
    handleClick() {
      if (!this.filePath) return;
      if (documentFileExtReg.test(this.filePath)) {
        window.open(`https://view.officeapps.live.com/op/view.aspx?src=${this.filePath}`, '_blank');
        return;
      }
      window.open(this.filePath, '_blank');
    }
  }
};